// extracted by mini-css-extract-plugin
export default {"wrapeer":"NormalSizeLinks_wrapeer__ezBgf"};